import { GetExcursionsMyMSCResponse } from '@msc-b2c/interfaces/interfaces';
import { PriceBasisEnum } from '@msc-b2c/interfaces/enums';

export const excursionsMyMSCResponseMock: GetExcursionsMyMSCResponse = {
  excursions: [
    {
      code: 'CIV01',
      portCode: 'BCN',
      price: '500000.00',
      locationCode: 'ATC',
      description: 'PALMA DI MAIORCA, DAL CASTELLO ALLA CATTEDRALE',
      longDescription:
        "Questa escursione di quattro ore che vi svelerà Palma inizia con un tragitto di 20 minuti su strada dal porto fino al Castello di Bellver, una fortezza gotica che sovrasta la città dalla cima di una collina. Si tratta di uno dei pochi castelli di forma circolare presenti nel Mediterraneo: approfittate della sosta di 30 minuti e del panorama sulla città e sul Mar Mediterraneo per fare splendide foto ricordo all'esterno del sito. Successivamente, ripartirete verso Escollera, il molo principale di Palma. Approfittate al massimo delle due ore successive perdendovi nella città vecchia, sia in compagnia di una guida esperta che vi farà ammirare dall'esterno Palazzo dell'Almudaina, Piazza Cort con il Municipio, Plaza Mayor e Piazza Santa Eulalia, sia con tempo libero a vostra disposizione. Il tour fa tappa alla cattedrale di Palma, una costruzione imponente che sembra dominare dall'alto l'intera città e che visiterete. La cattedrale di Santa Maria, nota anche come La Seu, è stata fondata nel XIII secolo, ma la sua costruzione non è stata completata fino ai primi anni del XVII secolo. Con i 44 m di altezza delle sue volte, è una delle cattedrali più alte d'Europa. Nel museo accanto, scoprirete i dettagli del restauro della cattedrale realizzato dal famoso architetto catalano Antoni Gaudí, con del tempo libero prima del tragitto di 20 minuti per ritornare al porto.&lt;p class='ptec'&gt;Nota bene: in caso di chiusura i giorni festivi o in caso di celebrazioni religiose, la guida fornirà le informazioni all'esterno della Cattedrale. Per la visita dei luoghi di culto, è richiesto un abbigliamento adeguato. Escursione non adatta a ospiti con problemi di deambulazione. Il percorso per raggiungere la Cattedrale dal parcheggio dei pullman prevede dover salire circa 100 gradini.&lt;/p&gt;",
      startDate: '2024-05-24',
      endDate: '2024-05-24',
      paymentType: 'PREPAID',
      duration: 1.5,
      currencyCode: 'GBP',
      images: {
        image: '/images/msc/ACT/PMI28.jpg',
        desktop: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
        mobile: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
      },
      video: 'http://www.mscwebtv.com/view/IT/our-excursions-in-barcelona-panoramic-tour-shopping',
      videoId: '57e45177-40ca-4492-b8fd-296aef955c38',
      videoDescription: 'Description of a video',
      promotion: {
        id: '123456',
        type: 'MARKUP',
        description: 'This is a description for a promotion.',
        webDescription: 'This is a description for a promotion.',
        validFrom: '2025-07-04T21:00:00',
        validTo: '2025-07-20T21:00:00',
      },
      isPackage: false,
      priceBasis: PriceBasisEnum.PER_PERSON,
      packageDetails: [
        {
          portCode: 'BCN',
          isGuideAvailable: true,
          code: 'BCN02',
          isBestSeller: true,
          activityGroup: {
            details: 'activity group details',
            description: 'activity group description',
          },
          difficultyLevel: 'EASY',
          longDescription:
            "Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza. Con un breve trasferimento di 15 minuti dal porto raggiungerete la collina del Montjuïc, dove farete una sosta per fotografare alcuni dei principali monumenti della città. Fra questi spicca la Sagrada Família, la straordinaria chiesa di Antoni Gaudí, cantiere aperto da oltre 140 anni. Dopo un percorso in autobus di 25 minuti, proseguirete a piedi per quindici minuti e raggiungere questo capolavoro architettonico. Durante una sosta all'esterno, potrete ammirare gli animali scolpiti che si mimetizzano sulla facciata, fra cui serpenti e lumache. La passeggiata di un quarto d'ora vi ricondurrà all'autobus per raggiungere in pochi minuti lo storico Barrio Gótico, sede della Cattedrale di Barcellona, costruita fra il XIII e il XV secolo. Concedetevi qualche minuto per contemplare la bellezza della facciata gotica e neogotica della cattedrale prima di dirigervi verso una delle aree dello shopping più famose della città: Plaça de Catalunya e Portal de l'Angel. Qui troverete catene di negozi spagnole e piccole botteghe storiche, alcune quasi centenarie: il luogo perfetto per fare un po' di shopping terapeutico durante i circa 90 minuti di tempo libero a vostra disposizione. Approfittatene per acquistare qualche souvenir, dalle espadrillas fatte a mano e le candele artigianali ai copricapi tradizionali, prima di far ritorno all'autobus che vi riaccompagnerà al porto in 15 minuti. In alternativa, potrete decidere di restare più a lungo nell'area per dare un'occhiata anche alle vicine Las Ramblas.&lt;p class='ptec'&gt;Nota bene: a causa delle restrizioni al traffico nell'area della Sagrada Familía, l'autobus si fermerà nelle vicinanze e gli ospiti dovranno camminare per 15 minuti a tratta. Gli ospiti che decidono di restare più a lungo in città faranno ritorno al porto da soli utilizzando il servizio navetta.&lt;/p&gt;",
          isWheelchairFriendly: true,
          isSnackIncluded: true,
          isMealIncluded: true,
          isBusTransportAvailable: false,
          images: {
            image: '/images/msc/ACT/PMI28.jpg',
            desktop: {
              image: '/content/dam/b2c-website-foundation/images/asset.jpg',
              optimisedImage:
                '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
            },
          },
          isDrinkIncluded: false,
          isSwimmingIncluded: false,
          isTastingIncluded: false,
          isFilmingAllowed: true,
          isShoppingIncluded: false,
          description:
            'Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza.',
          activityDetails: {
            isGuideAvailable: true,
            isTourActivity: false,
            isBestSeller: true,
            difficultyLevel: 'EASY',
            isWheelchairFriendly: true,
            isSnackIncluded: true,
            isFamilyFriendlyActivity: false,
            isBestRated: true,
            isLimitedSeats: false,
            isMealIncluded: true,
            isBusTransportAvailable: false,
            isDrinkIncluded: false,
            isSwimmingIncluded: false,
            notes: 'This is an activity note.',
            isTastingIncluded: false,
            isCulturalActivity: false,
            isFilmingAllowed: true,
            isShoppingIncluded: false,
            isWalkingDifficulty: false,
            isInvolvesWalking: false,
            guideLanguageCodes: ['ENG'],
          },
          guideLanguageCodes: ['ENG'],
          duration: 0,
        },
      ],
      prices: {
        perCabin: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perAdult: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perJunior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perChild: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perInfant: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perSenior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
      },
      activityDetails: {
        isGuideAvailable: true,
        isTourActivity: false,
        isBestSeller: true,
        difficultyLevel: 'EASY',
        isWheelchairFriendly: true,
        isSnackIncluded: true,
        isFamilyFriendlyActivity: false,
        isBestRated: true,
        isLimitedSeats: false,
        isMealIncluded: true,
        isBusTransportAvailable: false,
        isDrinkIncluded: false,
        isSwimmingIncluded: false,
        notes: 'This is an activity note.',
        isTastingIncluded: false,
        isShoppingIncluded: false,
        isFilmingAllowed: true,
        isCulturalActivity: false,
        isWalkingDifficulty: false,
        isInvolvesWalking: false,
        minimumPassengersRequired: 40,
        guideLanguageCodes: ['ENG'],
      },
      activityGroup: {
        details: 'activity details',
        description: 'activity description',
      },
      assets: [
        {
          excursion: {
            image: '/content/dam/b2c-website-foundation/images/asset.jpg',
            optimisedImage:
              '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
          },
          alternativeText: 'Alternative text here.',
        },
      ],
      inventory: {
        numberAvailable: '30',
        type: 'REQUEST',
      },
    },
    {
      code: 'CIV01',
      portCode: 'BCN',
      price: '500000.00',
      locationCode: 'ATC',
      description: 'PALMA DI MAIORCA, DAL CASTELLO ALLA CATTEDRALE',
      longDescription:
        "Questa escursione di quattro ore che vi svelerà Palma inizia con un tragitto di 20 minuti su strada dal porto fino al Castello di Bellver, una fortezza gotica che sovrasta la città dalla cima di una collina. Si tratta di uno dei pochi castelli di forma circolare presenti nel Mediterraneo: approfittate della sosta di 30 minuti e del panorama sulla città e sul Mar Mediterraneo per fare splendide foto ricordo all'esterno del sito. Successivamente, ripartirete verso Escollera, il molo principale di Palma. Approfittate al massimo delle due ore successive perdendovi nella città vecchia, sia in compagnia di una guida esperta che vi farà ammirare dall'esterno Palazzo dell'Almudaina, Piazza Cort con il Municipio, Plaza Mayor e Piazza Santa Eulalia, sia con tempo libero a vostra disposizione. Il tour fa tappa alla cattedrale di Palma, una costruzione imponente che sembra dominare dall'alto l'intera città e che visiterete. La cattedrale di Santa Maria, nota anche come La Seu, è stata fondata nel XIII secolo, ma la sua costruzione non è stata completata fino ai primi anni del XVII secolo. Con i 44 m di altezza delle sue volte, è una delle cattedrali più alte d'Europa. Nel museo accanto, scoprirete i dettagli del restauro della cattedrale realizzato dal famoso architetto catalano Antoni Gaudí, con del tempo libero prima del tragitto di 20 minuti per ritornare al porto.&lt;p class='ptec'&gt;Nota bene: in caso di chiusura i giorni festivi o in caso di celebrazioni religiose, la guida fornirà le informazioni all'esterno della Cattedrale. Per la visita dei luoghi di culto, è richiesto un abbigliamento adeguato. Escursione non adatta a ospiti con problemi di deambulazione. Il percorso per raggiungere la Cattedrale dal parcheggio dei pullman prevede dover salire circa 100 gradini.&lt;/p&gt;",
      startDate: '2024-05-24',
      endDate: '2024-05-24',
      paymentType: 'PREPAID',
      duration: 1.5,
      currencyCode: 'GBP',
      images: {
        image: '/images/msc/ACT/PMI28.jpg',
        desktop: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
        mobile: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
      },
      video: 'http://www.mscwebtv.com/view/IT/our-excursions-in-barcelona-panoramic-tour-shopping',
      videoId: '57e45177-40ca-4492-b8fd-296aef955c38',
      videoDescription: 'Description of a video',
      promotion: {
        id: '123456',
        type: 'MARKUP',
        description: 'This is a description for a promotion.',
        webDescription: 'This is a description for a promotion.',
        validFrom: '2025-07-04T21:00:00',
        validTo: '2025-07-20T21:00:00',
      },
      isPackage: false,
      priceBasis: PriceBasisEnum.PER_PERSON,
      packageDetails: [
        {
          portCode: 'BCN',
          isGuideAvailable: true,
          code: 'BCN02',
          isBestSeller: true,
          activityGroup: {
            details: 'activity group details',
            description: 'activity group description',
          },
          difficultyLevel: 'EASY',
          longDescription:
            "Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza. Con un breve trasferimento di 15 minuti dal porto raggiungerete la collina del Montjuïc, dove farete una sosta per fotografare alcuni dei principali monumenti della città. Fra questi spicca la Sagrada Família, la straordinaria chiesa di Antoni Gaudí, cantiere aperto da oltre 140 anni. Dopo un percorso in autobus di 25 minuti, proseguirete a piedi per quindici minuti e raggiungere questo capolavoro architettonico. Durante una sosta all'esterno, potrete ammirare gli animali scolpiti che si mimetizzano sulla facciata, fra cui serpenti e lumache. La passeggiata di un quarto d'ora vi ricondurrà all'autobus per raggiungere in pochi minuti lo storico Barrio Gótico, sede della Cattedrale di Barcellona, costruita fra il XIII e il XV secolo. Concedetevi qualche minuto per contemplare la bellezza della facciata gotica e neogotica della cattedrale prima di dirigervi verso una delle aree dello shopping più famose della città: Plaça de Catalunya e Portal de l'Angel. Qui troverete catene di negozi spagnole e piccole botteghe storiche, alcune quasi centenarie: il luogo perfetto per fare un po' di shopping terapeutico durante i circa 90 minuti di tempo libero a vostra disposizione. Approfittatene per acquistare qualche souvenir, dalle espadrillas fatte a mano e le candele artigianali ai copricapi tradizionali, prima di far ritorno all'autobus che vi riaccompagnerà al porto in 15 minuti. In alternativa, potrete decidere di restare più a lungo nell'area per dare un'occhiata anche alle vicine Las Ramblas.&lt;p class='ptec'&gt;Nota bene: a causa delle restrizioni al traffico nell'area della Sagrada Familía, l'autobus si fermerà nelle vicinanze e gli ospiti dovranno camminare per 15 minuti a tratta. Gli ospiti che decidono di restare più a lungo in città faranno ritorno al porto da soli utilizzando il servizio navetta.&lt;/p&gt;",
          isWheelchairFriendly: true,
          isSnackIncluded: true,
          isMealIncluded: true,
          isBusTransportAvailable: false,
          images: {
            image: '/images/msc/ACT/PMI28.jpg',
            desktop: {
              image: '/content/dam/b2c-website-foundation/images/asset.jpg',
              optimisedImage:
                '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
            },
          },
          isDrinkIncluded: false,
          isSwimmingIncluded: false,
          isTastingIncluded: false,
          isFilmingAllowed: true,
          isShoppingIncluded: false,
          description:
            'Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza.',
          activityDetails: {
            isGuideAvailable: true,
            isTourActivity: false,
            isBestSeller: true,
            difficultyLevel: 'EASY',
            isWheelchairFriendly: true,
            isSnackIncluded: true,
            isFamilyFriendlyActivity: false,
            isBestRated: true,
            isLimitedSeats: false,
            isMealIncluded: true,
            isBusTransportAvailable: false,
            isDrinkIncluded: false,
            isSwimmingIncluded: false,
            notes: 'This is an activity note.',
            isTastingIncluded: false,
            isCulturalActivity: false,
            isFilmingAllowed: true,
            isShoppingIncluded: false,
            isWalkingDifficulty: false,
            isInvolvesWalking: false,
            guideLanguageCodes: ['ENG'],
          },
          guideLanguageCodes: ['ENG'],
          duration: 0,
        },
      ],
      prices: {
        perCabin: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perAdult: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perJunior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perChild: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perInfant: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perSenior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
      },
      activityDetails: {
        isGuideAvailable: true,
        isTourActivity: false,
        isBestSeller: true,
        difficultyLevel: 'EASY',
        isWheelchairFriendly: true,
        isSnackIncluded: true,
        isFamilyFriendlyActivity: false,
        isBestRated: true,
        isLimitedSeats: false,
        isMealIncluded: true,
        isBusTransportAvailable: false,
        isDrinkIncluded: false,
        isSwimmingIncluded: false,
        notes: 'This is an activity note.',
        isTastingIncluded: false,
        isShoppingIncluded: false,
        isFilmingAllowed: true,
        isCulturalActivity: false,
        isWalkingDifficulty: false,
        isInvolvesWalking: false,
        minimumPassengersRequired: 40,
        guideLanguageCodes: ['ENG'],
      },
      activityGroup: {
        details: 'activity details',
        description: 'activity description',
      },
      assets: [
        {
          excursion: {
            image: '/content/dam/b2c-website-foundation/images/asset.jpg',
            optimisedImage:
              '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
          },
          alternativeText: 'Alternative text here.',
        },
      ],
      inventory: {
        numberAvailable: '30',
        type: 'REQUEST',
      },
    },
    {
      code: 'CIV01',
      portCode: 'BCN',
      price: '500000.00',
      locationCode: 'ATC',
      description: 'PALMA DI MAIORCA, DAL CASTELLO ALLA CATTEDRALE',
      longDescription:
        "Questa escursione di quattro ore che vi svelerà Palma inizia con un tragitto di 20 minuti su strada dal porto fino al Castello di Bellver, una fortezza gotica che sovrasta la città dalla cima di una collina. Si tratta di uno dei pochi castelli di forma circolare presenti nel Mediterraneo: approfittate della sosta di 30 minuti e del panorama sulla città e sul Mar Mediterraneo per fare splendide foto ricordo all'esterno del sito. Successivamente, ripartirete verso Escollera, il molo principale di Palma. Approfittate al massimo delle due ore successive perdendovi nella città vecchia, sia in compagnia di una guida esperta che vi farà ammirare dall'esterno Palazzo dell'Almudaina, Piazza Cort con il Municipio, Plaza Mayor e Piazza Santa Eulalia, sia con tempo libero a vostra disposizione. Il tour fa tappa alla cattedrale di Palma, una costruzione imponente che sembra dominare dall'alto l'intera città e che visiterete. La cattedrale di Santa Maria, nota anche come La Seu, è stata fondata nel XIII secolo, ma la sua costruzione non è stata completata fino ai primi anni del XVII secolo. Con i 44 m di altezza delle sue volte, è una delle cattedrali più alte d'Europa. Nel museo accanto, scoprirete i dettagli del restauro della cattedrale realizzato dal famoso architetto catalano Antoni Gaudí, con del tempo libero prima del tragitto di 20 minuti per ritornare al porto.&lt;p class='ptec'&gt;Nota bene: in caso di chiusura i giorni festivi o in caso di celebrazioni religiose, la guida fornirà le informazioni all'esterno della Cattedrale. Per la visita dei luoghi di culto, è richiesto un abbigliamento adeguato. Escursione non adatta a ospiti con problemi di deambulazione. Il percorso per raggiungere la Cattedrale dal parcheggio dei pullman prevede dover salire circa 100 gradini.&lt;/p&gt;",
      startDate: '2024-05-24',
      endDate: '2024-05-24',
      paymentType: 'PREPAID',
      duration: 1.5,
      currencyCode: 'GBP',
      images: {
        image: '/images/msc/ACT/PMI28.jpg',
        desktop: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
        mobile: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
      },
      video: 'http://www.mscwebtv.com/view/IT/our-excursions-in-barcelona-panoramic-tour-shopping',
      videoId: '57e45177-40ca-4492-b8fd-296aef955c38',
      videoDescription: 'Description of a video',
      promotion: {
        id: '123456',
        type: 'MARKUP',
        description: 'This is a description for a promotion.',
        webDescription: 'This is a description for a promotion.',
        validFrom: '2025-07-04T21:00:00',
        validTo: '2025-07-20T21:00:00',
      },
      isPackage: false,
      priceBasis: PriceBasisEnum.PER_PERSON,
      packageDetails: [
        {
          portCode: 'BCN',
          isGuideAvailable: true,
          code: 'BCN02',
          isBestSeller: true,
          activityGroup: {
            details: 'activity group details',
            description: 'activity group description',
          },
          difficultyLevel: 'EASY',
          longDescription:
            "Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza. Con un breve trasferimento di 15 minuti dal porto raggiungerete la collina del Montjuïc, dove farete una sosta per fotografare alcuni dei principali monumenti della città. Fra questi spicca la Sagrada Família, la straordinaria chiesa di Antoni Gaudí, cantiere aperto da oltre 140 anni. Dopo un percorso in autobus di 25 minuti, proseguirete a piedi per quindici minuti e raggiungere questo capolavoro architettonico. Durante una sosta all'esterno, potrete ammirare gli animali scolpiti che si mimetizzano sulla facciata, fra cui serpenti e lumache. La passeggiata di un quarto d'ora vi ricondurrà all'autobus per raggiungere in pochi minuti lo storico Barrio Gótico, sede della Cattedrale di Barcellona, costruita fra il XIII e il XV secolo. Concedetevi qualche minuto per contemplare la bellezza della facciata gotica e neogotica della cattedrale prima di dirigervi verso una delle aree dello shopping più famose della città: Plaça de Catalunya e Portal de l'Angel. Qui troverete catene di negozi spagnole e piccole botteghe storiche, alcune quasi centenarie: il luogo perfetto per fare un po' di shopping terapeutico durante i circa 90 minuti di tempo libero a vostra disposizione. Approfittatene per acquistare qualche souvenir, dalle espadrillas fatte a mano e le candele artigianali ai copricapi tradizionali, prima di far ritorno all'autobus che vi riaccompagnerà al porto in 15 minuti. In alternativa, potrete decidere di restare più a lungo nell'area per dare un'occhiata anche alle vicine Las Ramblas.&lt;p class='ptec'&gt;Nota bene: a causa delle restrizioni al traffico nell'area della Sagrada Familía, l'autobus si fermerà nelle vicinanze e gli ospiti dovranno camminare per 15 minuti a tratta. Gli ospiti che decidono di restare più a lungo in città faranno ritorno al porto da soli utilizzando il servizio navetta.&lt;/p&gt;",
          isWheelchairFriendly: true,
          isSnackIncluded: true,
          isMealIncluded: true,
          isBusTransportAvailable: false,
          images: {
            image: '/images/msc/ACT/PMI28.jpg',
            desktop: {
              image: '/content/dam/b2c-website-foundation/images/asset.jpg',
              optimisedImage:
                '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
            },
          },
          isDrinkIncluded: false,
          isSwimmingIncluded: false,
          isTastingIncluded: false,
          isFilmingAllowed: true,
          isShoppingIncluded: false,
          description:
            'Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza.',
          activityDetails: {
            isGuideAvailable: true,
            isTourActivity: false,
            isBestSeller: true,
            difficultyLevel: 'EASY',
            isWheelchairFriendly: true,
            isSnackIncluded: true,
            isFamilyFriendlyActivity: false,
            isBestRated: true,
            isLimitedSeats: false,
            isMealIncluded: true,
            isBusTransportAvailable: false,
            isDrinkIncluded: false,
            isSwimmingIncluded: false,
            notes: 'This is an activity note.',
            isTastingIncluded: false,
            isCulturalActivity: false,
            isFilmingAllowed: true,
            isShoppingIncluded: false,
            isWalkingDifficulty: false,
            isInvolvesWalking: false,
            guideLanguageCodes: ['ENG'],
          },
          guideLanguageCodes: ['ENG'],
          duration: 0,
        },
      ],
      prices: {
        perCabin: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perAdult: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perJunior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perChild: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perInfant: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perSenior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
      },
      activityDetails: {
        isGuideAvailable: true,
        isTourActivity: false,
        isBestSeller: true,
        difficultyLevel: 'EASY',
        isWheelchairFriendly: true,
        isSnackIncluded: true,
        isFamilyFriendlyActivity: false,
        isBestRated: true,
        isLimitedSeats: false,
        isMealIncluded: true,
        isBusTransportAvailable: false,
        isDrinkIncluded: false,
        isSwimmingIncluded: false,
        notes: 'This is an activity note.',
        isTastingIncluded: false,
        isShoppingIncluded: false,
        isFilmingAllowed: true,
        isCulturalActivity: false,
        isWalkingDifficulty: false,
        isInvolvesWalking: false,
        minimumPassengersRequired: 40,
        guideLanguageCodes: ['ENG'],
      },
      activityGroup: {
        details: 'activity details',
        description: 'activity description',
      },
      assets: [
        {
          excursion: {
            image: '/content/dam/b2c-website-foundation/images/asset.jpg',
            optimisedImage:
              '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
          },
          alternativeText: 'Alternative text here.',
        },
      ],
      inventory: {
        numberAvailable: '30',
        type: 'REQUEST',
      },
    },
    {
      code: 'CIV01',
      portCode: 'BCN',
      price: '500000.00',
      locationCode: 'ATC',
      description: 'PALMA DI MAIORCA, DAL CASTELLO ALLA CATTEDRALE',
      longDescription:
        "Questa escursione di quattro ore che vi svelerà Palma inizia con un tragitto di 20 minuti su strada dal porto fino al Castello di Bellver, una fortezza gotica che sovrasta la città dalla cima di una collina. Si tratta di uno dei pochi castelli di forma circolare presenti nel Mediterraneo: approfittate della sosta di 30 minuti e del panorama sulla città e sul Mar Mediterraneo per fare splendide foto ricordo all'esterno del sito. Successivamente, ripartirete verso Escollera, il molo principale di Palma. Approfittate al massimo delle due ore successive perdendovi nella città vecchia, sia in compagnia di una guida esperta che vi farà ammirare dall'esterno Palazzo dell'Almudaina, Piazza Cort con il Municipio, Plaza Mayor e Piazza Santa Eulalia, sia con tempo libero a vostra disposizione. Il tour fa tappa alla cattedrale di Palma, una costruzione imponente che sembra dominare dall'alto l'intera città e che visiterete. La cattedrale di Santa Maria, nota anche come La Seu, è stata fondata nel XIII secolo, ma la sua costruzione non è stata completata fino ai primi anni del XVII secolo. Con i 44 m di altezza delle sue volte, è una delle cattedrali più alte d'Europa. Nel museo accanto, scoprirete i dettagli del restauro della cattedrale realizzato dal famoso architetto catalano Antoni Gaudí, con del tempo libero prima del tragitto di 20 minuti per ritornare al porto.&lt;p class='ptec'&gt;Nota bene: in caso di chiusura i giorni festivi o in caso di celebrazioni religiose, la guida fornirà le informazioni all'esterno della Cattedrale. Per la visita dei luoghi di culto, è richiesto un abbigliamento adeguato. Escursione non adatta a ospiti con problemi di deambulazione. Il percorso per raggiungere la Cattedrale dal parcheggio dei pullman prevede dover salire circa 100 gradini.&lt;/p&gt;",
      startDate: '2024-05-24',
      endDate: '2024-05-24',
      paymentType: 'PREPAID',
      duration: 1.5,
      currencyCode: 'GBP',
      images: {
        image: '/images/msc/ACT/PMI28.jpg',
        desktop: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
        mobile: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
      },
      video: 'http://www.mscwebtv.com/view/IT/our-excursions-in-barcelona-panoramic-tour-shopping',
      videoId: '57e45177-40ca-4492-b8fd-296aef955c38',
      videoDescription: 'Description of a video',
      promotion: {
        id: '123456',
        type: 'MARKUP',
        description: 'This is a description for a promotion.',
        webDescription: 'This is a description for a promotion.',
        validFrom: '2025-07-04T21:00:00',
        validTo: '2025-07-20T21:00:00',
      },
      isPackage: false,
      priceBasis: PriceBasisEnum.PER_PERSON,
      packageDetails: [
        {
          portCode: 'BCN',
          isGuideAvailable: true,
          code: 'BCN02',
          isBestSeller: true,
          activityGroup: {
            details: 'activity group details',
            description: 'activity group description',
          },
          difficultyLevel: 'EASY',
          longDescription:
            "Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza. Con un breve trasferimento di 15 minuti dal porto raggiungerete la collina del Montjuïc, dove farete una sosta per fotografare alcuni dei principali monumenti della città. Fra questi spicca la Sagrada Família, la straordinaria chiesa di Antoni Gaudí, cantiere aperto da oltre 140 anni. Dopo un percorso in autobus di 25 minuti, proseguirete a piedi per quindici minuti e raggiungere questo capolavoro architettonico. Durante una sosta all'esterno, potrete ammirare gli animali scolpiti che si mimetizzano sulla facciata, fra cui serpenti e lumache. La passeggiata di un quarto d'ora vi ricondurrà all'autobus per raggiungere in pochi minuti lo storico Barrio Gótico, sede della Cattedrale di Barcellona, costruita fra il XIII e il XV secolo. Concedetevi qualche minuto per contemplare la bellezza della facciata gotica e neogotica della cattedrale prima di dirigervi verso una delle aree dello shopping più famose della città: Plaça de Catalunya e Portal de l'Angel. Qui troverete catene di negozi spagnole e piccole botteghe storiche, alcune quasi centenarie: il luogo perfetto per fare un po' di shopping terapeutico durante i circa 90 minuti di tempo libero a vostra disposizione. Approfittatene per acquistare qualche souvenir, dalle espadrillas fatte a mano e le candele artigianali ai copricapi tradizionali, prima di far ritorno all'autobus che vi riaccompagnerà al porto in 15 minuti. In alternativa, potrete decidere di restare più a lungo nell'area per dare un'occhiata anche alle vicine Las Ramblas.&lt;p class='ptec'&gt;Nota bene: a causa delle restrizioni al traffico nell'area della Sagrada Familía, l'autobus si fermerà nelle vicinanze e gli ospiti dovranno camminare per 15 minuti a tratta. Gli ospiti che decidono di restare più a lungo in città faranno ritorno al porto da soli utilizzando il servizio navetta.&lt;/p&gt;",
          isWheelchairFriendly: true,
          isSnackIncluded: true,
          isMealIncluded: true,
          isBusTransportAvailable: false,
          images: {
            image: '/images/msc/ACT/PMI28.jpg',
            desktop: {
              image: '/content/dam/b2c-website-foundation/images/asset.jpg',
              optimisedImage:
                '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
            },
          },
          isDrinkIncluded: false,
          isSwimmingIncluded: false,
          isTastingIncluded: false,
          isFilmingAllowed: true,
          isShoppingIncluded: false,
          description:
            'Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza.',
          activityDetails: {
            isGuideAvailable: true,
            isTourActivity: false,
            isBestSeller: true,
            difficultyLevel: 'EASY',
            isWheelchairFriendly: true,
            isSnackIncluded: true,
            isFamilyFriendlyActivity: false,
            isBestRated: true,
            isLimitedSeats: false,
            isMealIncluded: true,
            isBusTransportAvailable: false,
            isDrinkIncluded: false,
            isSwimmingIncluded: false,
            notes: 'This is an activity note.',
            isTastingIncluded: false,
            isCulturalActivity: false,
            isFilmingAllowed: true,
            isShoppingIncluded: false,
            isWalkingDifficulty: false,
            isInvolvesWalking: false,
            guideLanguageCodes: ['ENG'],
          },
          guideLanguageCodes: ['ENG'],
          duration: 0,
        },
      ],
      prices: {
        perCabin: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perAdult: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perJunior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perChild: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perInfant: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perSenior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
      },
      activityDetails: {
        isGuideAvailable: true,
        isTourActivity: false,
        isBestSeller: true,
        difficultyLevel: 'EASY',
        isWheelchairFriendly: true,
        isSnackIncluded: true,
        isFamilyFriendlyActivity: false,
        isBestRated: true,
        isLimitedSeats: false,
        isMealIncluded: true,
        isBusTransportAvailable: false,
        isDrinkIncluded: false,
        isSwimmingIncluded: false,
        notes: 'This is an activity note.',
        isTastingIncluded: false,
        isShoppingIncluded: false,
        isFilmingAllowed: true,
        isCulturalActivity: false,
        isWalkingDifficulty: false,
        isInvolvesWalking: false,
        minimumPassengersRequired: 40,
        guideLanguageCodes: ['ENG'],
      },
      activityGroup: {
        details: 'activity details',
        description: 'activity description',
      },
      assets: [
        {
          excursion: {
            image: '/content/dam/b2c-website-foundation/images/asset.jpg',
            optimisedImage:
              '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
          },
          alternativeText: 'Alternative text here.',
        },
      ],
      inventory: {
        numberAvailable: '30',
        type: 'REQUEST',
      },
    },
    {
      code: 'CIV01',
      portCode: 'BCN',
      price: '500000.00',
      locationCode: 'ATC',
      description: 'PALMA DI MAIORCA, DAL CASTELLO ALLA CATTEDRALE',
      longDescription:
        "Questa escursione di quattro ore che vi svelerà Palma inizia con un tragitto di 20 minuti su strada dal porto fino al Castello di Bellver, una fortezza gotica che sovrasta la città dalla cima di una collina. Si tratta di uno dei pochi castelli di forma circolare presenti nel Mediterraneo: approfittate della sosta di 30 minuti e del panorama sulla città e sul Mar Mediterraneo per fare splendide foto ricordo all'esterno del sito. Successivamente, ripartirete verso Escollera, il molo principale di Palma. Approfittate al massimo delle due ore successive perdendovi nella città vecchia, sia in compagnia di una guida esperta che vi farà ammirare dall'esterno Palazzo dell'Almudaina, Piazza Cort con il Municipio, Plaza Mayor e Piazza Santa Eulalia, sia con tempo libero a vostra disposizione. Il tour fa tappa alla cattedrale di Palma, una costruzione imponente che sembra dominare dall'alto l'intera città e che visiterete. La cattedrale di Santa Maria, nota anche come La Seu, è stata fondata nel XIII secolo, ma la sua costruzione non è stata completata fino ai primi anni del XVII secolo. Con i 44 m di altezza delle sue volte, è una delle cattedrali più alte d'Europa. Nel museo accanto, scoprirete i dettagli del restauro della cattedrale realizzato dal famoso architetto catalano Antoni Gaudí, con del tempo libero prima del tragitto di 20 minuti per ritornare al porto.&lt;p class='ptec'&gt;Nota bene: in caso di chiusura i giorni festivi o in caso di celebrazioni religiose, la guida fornirà le informazioni all'esterno della Cattedrale. Per la visita dei luoghi di culto, è richiesto un abbigliamento adeguato. Escursione non adatta a ospiti con problemi di deambulazione. Il percorso per raggiungere la Cattedrale dal parcheggio dei pullman prevede dover salire circa 100 gradini.&lt;/p&gt;",
      startDate: '2024-05-24',
      endDate: '2024-05-24',
      paymentType: 'PREPAID',
      duration: 1.5,
      currencyCode: 'GBP',
      images: {
        image: '/images/msc/ACT/PMI28.jpg',
        desktop: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
        mobile: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
      },
      video: 'http://www.mscwebtv.com/view/IT/our-excursions-in-barcelona-panoramic-tour-shopping',
      videoId: '57e45177-40ca-4492-b8fd-296aef955c38',
      videoDescription: 'Description of a video',
      promotion: {
        id: '123456',
        type: 'MARKUP',
        description: 'This is a description for a promotion.',
        webDescription: 'This is a description for a promotion.',
        validFrom: '2025-07-04T21:00:00',
        validTo: '2025-07-20T21:00:00',
      },
      isPackage: false,
      priceBasis: PriceBasisEnum.PER_PERSON,
      packageDetails: [
        {
          portCode: 'BCN',
          isGuideAvailable: true,
          code: 'BCN02',
          isBestSeller: true,
          activityGroup: {
            details: 'activity group details',
            description: 'activity group description',
          },
          difficultyLevel: 'EASY',
          longDescription:
            "Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza. Con un breve trasferimento di 15 minuti dal porto raggiungerete la collina del Montjuïc, dove farete una sosta per fotografare alcuni dei principali monumenti della città. Fra questi spicca la Sagrada Família, la straordinaria chiesa di Antoni Gaudí, cantiere aperto da oltre 140 anni. Dopo un percorso in autobus di 25 minuti, proseguirete a piedi per quindici minuti e raggiungere questo capolavoro architettonico. Durante una sosta all'esterno, potrete ammirare gli animali scolpiti che si mimetizzano sulla facciata, fra cui serpenti e lumache. La passeggiata di un quarto d'ora vi ricondurrà all'autobus per raggiungere in pochi minuti lo storico Barrio Gótico, sede della Cattedrale di Barcellona, costruita fra il XIII e il XV secolo. Concedetevi qualche minuto per contemplare la bellezza della facciata gotica e neogotica della cattedrale prima di dirigervi verso una delle aree dello shopping più famose della città: Plaça de Catalunya e Portal de l'Angel. Qui troverete catene di negozi spagnole e piccole botteghe storiche, alcune quasi centenarie: il luogo perfetto per fare un po' di shopping terapeutico durante i circa 90 minuti di tempo libero a vostra disposizione. Approfittatene per acquistare qualche souvenir, dalle espadrillas fatte a mano e le candele artigianali ai copricapi tradizionali, prima di far ritorno all'autobus che vi riaccompagnerà al porto in 15 minuti. In alternativa, potrete decidere di restare più a lungo nell'area per dare un'occhiata anche alle vicine Las Ramblas.&lt;p class='ptec'&gt;Nota bene: a causa delle restrizioni al traffico nell'area della Sagrada Familía, l'autobus si fermerà nelle vicinanze e gli ospiti dovranno camminare per 15 minuti a tratta. Gli ospiti che decidono di restare più a lungo in città faranno ritorno al porto da soli utilizzando il servizio navetta.&lt;/p&gt;",
          isWheelchairFriendly: true,
          isSnackIncluded: true,
          isMealIncluded: true,
          isBusTransportAvailable: false,
          images: {
            image: '/images/msc/ACT/PMI28.jpg',
            desktop: {
              image: '/content/dam/b2c-website-foundation/images/asset.jpg',
              optimisedImage:
                '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
            },
          },
          isDrinkIncluded: false,
          isSwimmingIncluded: false,
          isTastingIncluded: false,
          isFilmingAllowed: true,
          isShoppingIncluded: false,
          description:
            'Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza.',
          activityDetails: {
            isGuideAvailable: true,
            isTourActivity: false,
            isBestSeller: true,
            difficultyLevel: 'EASY',
            isWheelchairFriendly: true,
            isSnackIncluded: true,
            isFamilyFriendlyActivity: false,
            isBestRated: true,
            isLimitedSeats: false,
            isMealIncluded: true,
            isBusTransportAvailable: false,
            isDrinkIncluded: false,
            isSwimmingIncluded: false,
            notes: 'This is an activity note.',
            isTastingIncluded: false,
            isCulturalActivity: false,
            isFilmingAllowed: true,
            isShoppingIncluded: false,
            isWalkingDifficulty: false,
            isInvolvesWalking: false,
            guideLanguageCodes: ['ENG'],
          },
          guideLanguageCodes: ['ENG'],
          duration: 0,
        },
      ],
      prices: {
        perCabin: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perAdult: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perJunior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perChild: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perInfant: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perSenior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
      },
      activityDetails: {
        isGuideAvailable: true,
        isTourActivity: false,
        isBestSeller: true,
        difficultyLevel: 'EASY',
        isWheelchairFriendly: true,
        isSnackIncluded: true,
        isFamilyFriendlyActivity: false,
        isBestRated: true,
        isLimitedSeats: false,
        isMealIncluded: true,
        isBusTransportAvailable: false,
        isDrinkIncluded: false,
        isSwimmingIncluded: false,
        notes: 'This is an activity note.',
        isTastingIncluded: false,
        isShoppingIncluded: false,
        isFilmingAllowed: true,
        isCulturalActivity: false,
        isWalkingDifficulty: false,
        isInvolvesWalking: false,
        minimumPassengersRequired: 40,
        guideLanguageCodes: ['ENG'],
      },
      activityGroup: {
        details: 'activity details',
        description: 'activity description',
      },
      assets: [
        {
          excursion: {
            image: '/content/dam/b2c-website-foundation/images/asset.jpg',
            optimisedImage:
              '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
          },
          alternativeText: 'Alternative text here.',
        },
      ],
      inventory: {
        numberAvailable: '30',
        type: 'REQUEST',
      },
    },
    {
      code: 'CIV01',
      portCode: 'BCN',
      price: '500000.00',
      locationCode: 'ATC',
      description: 'PALMA DI MAIORCA, DAL CASTELLO ALLA CATTEDRALE',
      longDescription:
        "Questa escursione di quattro ore che vi svelerà Palma inizia con un tragitto di 20 minuti su strada dal porto fino al Castello di Bellver, una fortezza gotica che sovrasta la città dalla cima di una collina. Si tratta di uno dei pochi castelli di forma circolare presenti nel Mediterraneo: approfittate della sosta di 30 minuti e del panorama sulla città e sul Mar Mediterraneo per fare splendide foto ricordo all'esterno del sito. Successivamente, ripartirete verso Escollera, il molo principale di Palma. Approfittate al massimo delle due ore successive perdendovi nella città vecchia, sia in compagnia di una guida esperta che vi farà ammirare dall'esterno Palazzo dell'Almudaina, Piazza Cort con il Municipio, Plaza Mayor e Piazza Santa Eulalia, sia con tempo libero a vostra disposizione. Il tour fa tappa alla cattedrale di Palma, una costruzione imponente che sembra dominare dall'alto l'intera città e che visiterete. La cattedrale di Santa Maria, nota anche come La Seu, è stata fondata nel XIII secolo, ma la sua costruzione non è stata completata fino ai primi anni del XVII secolo. Con i 44 m di altezza delle sue volte, è una delle cattedrali più alte d'Europa. Nel museo accanto, scoprirete i dettagli del restauro della cattedrale realizzato dal famoso architetto catalano Antoni Gaudí, con del tempo libero prima del tragitto di 20 minuti per ritornare al porto.&lt;p class='ptec'&gt;Nota bene: in caso di chiusura i giorni festivi o in caso di celebrazioni religiose, la guida fornirà le informazioni all'esterno della Cattedrale. Per la visita dei luoghi di culto, è richiesto un abbigliamento adeguato. Escursione non adatta a ospiti con problemi di deambulazione. Il percorso per raggiungere la Cattedrale dal parcheggio dei pullman prevede dover salire circa 100 gradini.&lt;/p&gt;",
      startDate: '2024-05-24',
      endDate: '2024-05-24',
      paymentType: 'PREPAID',
      duration: 1.5,
      currencyCode: 'GBP',
      images: {
        image: '/images/msc/ACT/PMI28.jpg',
        desktop: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
        mobile: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
      },
      video: 'http://www.mscwebtv.com/view/IT/our-excursions-in-barcelona-panoramic-tour-shopping',
      videoId: '57e45177-40ca-4492-b8fd-296aef955c38',
      videoDescription: 'Description of a video',
      promotion: {
        id: '123456',
        type: 'MARKUP',
        description: 'This is a description for a promotion.',
        webDescription: 'This is a description for a promotion.',
        validFrom: '2025-07-04T21:00:00',
        validTo: '2025-07-20T21:00:00',
      },
      isPackage: false,
      priceBasis: PriceBasisEnum.PER_PERSON,
      packageDetails: [
        {
          portCode: 'BCN',
          isGuideAvailable: true,
          code: 'BCN02',
          isBestSeller: true,
          activityGroup: {
            details: 'activity group details',
            description: 'activity group description',
          },
          difficultyLevel: 'EASY',
          longDescription:
            "Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza. Con un breve trasferimento di 15 minuti dal porto raggiungerete la collina del Montjuïc, dove farete una sosta per fotografare alcuni dei principali monumenti della città. Fra questi spicca la Sagrada Família, la straordinaria chiesa di Antoni Gaudí, cantiere aperto da oltre 140 anni. Dopo un percorso in autobus di 25 minuti, proseguirete a piedi per quindici minuti e raggiungere questo capolavoro architettonico. Durante una sosta all'esterno, potrete ammirare gli animali scolpiti che si mimetizzano sulla facciata, fra cui serpenti e lumache. La passeggiata di un quarto d'ora vi ricondurrà all'autobus per raggiungere in pochi minuti lo storico Barrio Gótico, sede della Cattedrale di Barcellona, costruita fra il XIII e il XV secolo. Concedetevi qualche minuto per contemplare la bellezza della facciata gotica e neogotica della cattedrale prima di dirigervi verso una delle aree dello shopping più famose della città: Plaça de Catalunya e Portal de l'Angel. Qui troverete catene di negozi spagnole e piccole botteghe storiche, alcune quasi centenarie: il luogo perfetto per fare un po' di shopping terapeutico durante i circa 90 minuti di tempo libero a vostra disposizione. Approfittatene per acquistare qualche souvenir, dalle espadrillas fatte a mano e le candele artigianali ai copricapi tradizionali, prima di far ritorno all'autobus che vi riaccompagnerà al porto in 15 minuti. In alternativa, potrete decidere di restare più a lungo nell'area per dare un'occhiata anche alle vicine Las Ramblas.&lt;p class='ptec'&gt;Nota bene: a causa delle restrizioni al traffico nell'area della Sagrada Familía, l'autobus si fermerà nelle vicinanze e gli ospiti dovranno camminare per 15 minuti a tratta. Gli ospiti che decidono di restare più a lungo in città faranno ritorno al porto da soli utilizzando il servizio navetta.&lt;/p&gt;",
          isWheelchairFriendly: true,
          isSnackIncluded: true,
          isMealIncluded: true,
          isBusTransportAvailable: false,
          images: {
            image: '/images/msc/ACT/PMI28.jpg',
            desktop: {
              image: '/content/dam/b2c-website-foundation/images/asset.jpg',
              optimisedImage:
                '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
            },
          },
          isDrinkIncluded: false,
          isSwimmingIncluded: false,
          isTastingIncluded: false,
          isFilmingAllowed: true,
          isShoppingIncluded: false,
          description:
            'Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza.',
          activityDetails: {
            isGuideAvailable: true,
            isTourActivity: false,
            isBestSeller: true,
            difficultyLevel: 'EASY',
            isWheelchairFriendly: true,
            isSnackIncluded: true,
            isFamilyFriendlyActivity: false,
            isBestRated: true,
            isLimitedSeats: false,
            isMealIncluded: true,
            isBusTransportAvailable: false,
            isDrinkIncluded: false,
            isSwimmingIncluded: false,
            notes: 'This is an activity note.',
            isTastingIncluded: false,
            isCulturalActivity: false,
            isFilmingAllowed: true,
            isShoppingIncluded: false,
            isWalkingDifficulty: false,
            isInvolvesWalking: false,
            guideLanguageCodes: ['ENG'],
          },
          guideLanguageCodes: ['ENG'],
          duration: 0,
        },
      ],
      prices: {
        perCabin: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perAdult: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perJunior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perChild: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perInfant: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perSenior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
      },
      activityDetails: {
        isGuideAvailable: true,
        isTourActivity: false,
        isBestSeller: true,
        difficultyLevel: 'EASY',
        isWheelchairFriendly: true,
        isSnackIncluded: true,
        isFamilyFriendlyActivity: false,
        isBestRated: true,
        isLimitedSeats: false,
        isMealIncluded: true,
        isBusTransportAvailable: false,
        isDrinkIncluded: false,
        isSwimmingIncluded: false,
        notes: 'This is an activity note.',
        isTastingIncluded: false,
        isShoppingIncluded: false,
        isFilmingAllowed: true,
        isCulturalActivity: false,
        isWalkingDifficulty: false,
        isInvolvesWalking: false,
        minimumPassengersRequired: 40,
        guideLanguageCodes: ['ENG'],
      },
      activityGroup: {
        details: 'activity details',
        description: 'activity description',
      },
      assets: [
        {
          excursion: {
            image: '/content/dam/b2c-website-foundation/images/asset.jpg',
            optimisedImage:
              '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
          },
          alternativeText: 'Alternative text here.',
        },
      ],
      inventory: {
        numberAvailable: '30',
        type: 'REQUEST',
      },
    },
    {
      code: 'CIV01',
      portCode: 'BCN',
      price: '500000.00',
      locationCode: 'ATC',
      description: 'PALMA DI MAIORCA, DAL CASTELLO ALLA CATTEDRALE',
      longDescription:
        "Questa escursione di quattro ore che vi svelerà Palma inizia con un tragitto di 20 minuti su strada dal porto fino al Castello di Bellver, una fortezza gotica che sovrasta la città dalla cima di una collina. Si tratta di uno dei pochi castelli di forma circolare presenti nel Mediterraneo: approfittate della sosta di 30 minuti e del panorama sulla città e sul Mar Mediterraneo per fare splendide foto ricordo all'esterno del sito. Successivamente, ripartirete verso Escollera, il molo principale di Palma. Approfittate al massimo delle due ore successive perdendovi nella città vecchia, sia in compagnia di una guida esperta che vi farà ammirare dall'esterno Palazzo dell'Almudaina, Piazza Cort con il Municipio, Plaza Mayor e Piazza Santa Eulalia, sia con tempo libero a vostra disposizione. Il tour fa tappa alla cattedrale di Palma, una costruzione imponente che sembra dominare dall'alto l'intera città e che visiterete. La cattedrale di Santa Maria, nota anche come La Seu, è stata fondata nel XIII secolo, ma la sua costruzione non è stata completata fino ai primi anni del XVII secolo. Con i 44 m di altezza delle sue volte, è una delle cattedrali più alte d'Europa. Nel museo accanto, scoprirete i dettagli del restauro della cattedrale realizzato dal famoso architetto catalano Antoni Gaudí, con del tempo libero prima del tragitto di 20 minuti per ritornare al porto.&lt;p class='ptec'&gt;Nota bene: in caso di chiusura i giorni festivi o in caso di celebrazioni religiose, la guida fornirà le informazioni all'esterno della Cattedrale. Per la visita dei luoghi di culto, è richiesto un abbigliamento adeguato. Escursione non adatta a ospiti con problemi di deambulazione. Il percorso per raggiungere la Cattedrale dal parcheggio dei pullman prevede dover salire circa 100 gradini.&lt;/p&gt;",
      startDate: '2024-05-24',
      endDate: '2024-05-24',
      paymentType: 'PREPAID',
      duration: 1.5,
      currencyCode: 'GBP',
      images: {
        image: '/images/msc/ACT/PMI28.jpg',
        desktop: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
        mobile: {
          image: '/content/dam/b2c-website-foundation/images/asset.jpg',
          optimisedImage:
            '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
        },
      },
      video: 'http://www.mscwebtv.com/view/IT/our-excursions-in-barcelona-panoramic-tour-shopping',
      videoId: '57e45177-40ca-4492-b8fd-296aef955c38',
      videoDescription: 'Description of a video',
      promotion: {
        id: '123456',
        type: 'MARKUP',
        description: 'This is a description for a promotion.',
        webDescription: 'This is a description for a promotion.',
        validFrom: '2025-07-04T21:00:00',
        validTo: '2025-07-20T21:00:00',
      },
      isPackage: false,
      priceBasis: PriceBasisEnum.PER_PERSON,
      packageDetails: [
        {
          portCode: 'BCN',
          isGuideAvailable: true,
          code: 'BCN02',
          isBestSeller: true,
          activityGroup: {
            details: 'activity group details',
            description: 'activity group description',
          },
          difficultyLevel: 'EASY',
          longDescription:
            "Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza. Con un breve trasferimento di 15 minuti dal porto raggiungerete la collina del Montjuïc, dove farete una sosta per fotografare alcuni dei principali monumenti della città. Fra questi spicca la Sagrada Família, la straordinaria chiesa di Antoni Gaudí, cantiere aperto da oltre 140 anni. Dopo un percorso in autobus di 25 minuti, proseguirete a piedi per quindici minuti e raggiungere questo capolavoro architettonico. Durante una sosta all'esterno, potrete ammirare gli animali scolpiti che si mimetizzano sulla facciata, fra cui serpenti e lumache. La passeggiata di un quarto d'ora vi ricondurrà all'autobus per raggiungere in pochi minuti lo storico Barrio Gótico, sede della Cattedrale di Barcellona, costruita fra il XIII e il XV secolo. Concedetevi qualche minuto per contemplare la bellezza della facciata gotica e neogotica della cattedrale prima di dirigervi verso una delle aree dello shopping più famose della città: Plaça de Catalunya e Portal de l'Angel. Qui troverete catene di negozi spagnole e piccole botteghe storiche, alcune quasi centenarie: il luogo perfetto per fare un po' di shopping terapeutico durante i circa 90 minuti di tempo libero a vostra disposizione. Approfittatene per acquistare qualche souvenir, dalle espadrillas fatte a mano e le candele artigianali ai copricapi tradizionali, prima di far ritorno all'autobus che vi riaccompagnerà al porto in 15 minuti. In alternativa, potrete decidere di restare più a lungo nell'area per dare un'occhiata anche alle vicine Las Ramblas.&lt;p class='ptec'&gt;Nota bene: a causa delle restrizioni al traffico nell'area della Sagrada Familía, l'autobus si fermerà nelle vicinanze e gli ospiti dovranno camminare per 15 minuti a tratta. Gli ospiti che decidono di restare più a lungo in città faranno ritorno al porto da soli utilizzando il servizio navetta.&lt;/p&gt;",
          isWheelchairFriendly: true,
          isSnackIncluded: true,
          isMealIncluded: true,
          isBusTransportAvailable: false,
          images: {
            image: '/images/msc/ACT/PMI28.jpg',
            desktop: {
              image: '/content/dam/b2c-website-foundation/images/asset.jpg',
              optimisedImage:
                '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
            },
          },
          isDrinkIncluded: false,
          isSwimmingIncluded: false,
          isTastingIncluded: false,
          isFilmingAllowed: true,
          isShoppingIncluded: false,
          description:
            'Visitate alcune delle attrazioni più belle della capitale catalana durante questa intensa escursione di quattro ore e mezza.',
          activityDetails: {
            isGuideAvailable: true,
            isTourActivity: false,
            isBestSeller: true,
            difficultyLevel: 'EASY',
            isWheelchairFriendly: true,
            isSnackIncluded: true,
            isFamilyFriendlyActivity: false,
            isBestRated: true,
            isLimitedSeats: false,
            isMealIncluded: true,
            isBusTransportAvailable: false,
            isDrinkIncluded: false,
            isSwimmingIncluded: false,
            notes: 'This is an activity note.',
            isTastingIncluded: false,
            isCulturalActivity: false,
            isFilmingAllowed: true,
            isShoppingIncluded: false,
            isWalkingDifficulty: false,
            isInvolvesWalking: false,
            guideLanguageCodes: ['ENG'],
          },
          guideLanguageCodes: ['ENG'],
          duration: 0,
        },
      ],
      prices: {
        perCabin: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perAdult: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perJunior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perChild: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perInfant: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
        perSenior: {
          total: {
            beforeDiscount: '500000.00',
            afterDiscount: '500000.00',
          },
          discountPercentage: '',
          tax: '500000.00',
        },
      },
      activityDetails: {
        isGuideAvailable: true,
        isTourActivity: false,
        isBestSeller: true,
        difficultyLevel: 'EASY',
        isWheelchairFriendly: true,
        isSnackIncluded: true,
        isFamilyFriendlyActivity: false,
        isBestRated: true,
        isLimitedSeats: false,
        isMealIncluded: true,
        isBusTransportAvailable: false,
        isDrinkIncluded: false,
        isSwimmingIncluded: false,
        notes: 'This is an activity note.',
        isTastingIncluded: false,
        isShoppingIncluded: false,
        isFilmingAllowed: true,
        isCulturalActivity: false,
        isWalkingDifficulty: false,
        isInvolvesWalking: false,
        minimumPassengersRequired: 40,
        guideLanguageCodes: ['ENG'],
      },
      activityGroup: {
        details: 'activity details',
        description: 'activity description',
      },
      assets: [
        {
          excursion: {
            image: '/content/dam/b2c-website-foundation/images/asset.jpg',
            optimisedImage:
              '/adobe/dynamicmedia/deliver/dm-p-oid--8nkGVarlOr1OgqRAHz7GAIUPgiVReqGvv4mhl53HAkoacqBZ4o9oLLB4y3s47ZF8l22phEkfD4GujkAU2vaN-A/asset.jpg?preferwebp=true',
          },
          alternativeText: 'Alternative text here.',
        },
      ],
      inventory: {
        numberAvailable: '30',
        type: 'REQUEST',
      },
    },
  ],
};
